import { render, staticRenderFns } from "./hour.vue?vue&type=template&id=4b31040d&"
import script from "./hour.vue?vue&type=script&lang=js&"
export * from "./hour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports